

<div class="card">
  <!-- Grid and Kanban pin the stats row + filters and scroll only the content
       below; the list view keeps p-table's own scrolling. -->
  <div class="card-content"
       [class.card-content--fixed-header]="viewMode === 'grid' || viewMode === 'kanban'">
    <div class="stats-cards-row">
      <div class="stats-card stats-card--total">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ totalProjectsCount }}</span>
          <span class="stats-card-label">Total Projects</span>
          <span class="stats-card-sublabel">Active projects</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-briefcase"></i></div>
      </div>
      <div class="stats-card stats-card--total">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ filteredCount }}</span>
          <span class="stats-card-label">Showing</span>
          <span class="stats-card-sublabel">After filters</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-filter"></i></div>
      </div>
    </div>

    <div class="filter-bar filter-bar-collapsible mb-4" [class.filter-bar-visible]="pageHeaderService.currentFiltersVisible">
      <div class="filter-bar-filters">
        <div class="filter-field">
          <label for="managerFilter" class="filter-label">Project Manager</label>
          <p-select id="managerFilter" [(ngModel)]="selectedManagerFilter" (ngModelChange)="onManagerFilterChange()"
            [options]="managerFilterOptions" optionLabel="label" optionValue="value" placeholder="All"
            [showClear]="true" [filter]="true" filterPlaceholder="Search project manager..."
            panelStyleClass="filter-dropdown-panel" appendTo="body" />
        </div>
        <div class="filter-field">
          <label for="serviceGroupFilter" class="filter-label">Service Group</label>
          <p-select id="serviceGroupFilter" [(ngModel)]="selectedServiceGroupFilter"
            (ngModelChange)="onServiceGroupFilterChange()" [options]="serviceGroupFilterOptions"
            optionLabel="label" optionValue="value" placeholder="All" [showClear]="true"
            [filter]="true" filterPlaceholder="Search service group..."
            panelStyleClass="filter-dropdown-panel" appendTo="body" />
        </div>
        <div class="filter-field">
          <label for="statusFilter" class="filter-label">Status</label>
          <p-select id="statusFilter" [(ngModel)]="selectedStatusFilter" (ngModelChange)="onStatusFilterChange()"
            [options]="statusFilterOptions" optionLabel="label" optionValue="value" placeholder="All"
            [showClear]="true" [filter]="true" filterPlaceholder="Search status..."
            panelStyleClass="filter-dropdown-panel" appendTo="body" />
        </div>
        <div class="filter-field">
          <label for="progressFilter" class="filter-label">Progress</label>
          <p-select id="progressFilter" [(ngModel)]="selectedProgressFilter" (ngModelChange)="onProgressFilterChange()"
            [options]="progressFilterOptions" optionLabel="label" optionValue="value" placeholder="All"
            [showClear]="true" [filter]="true" filterPlaceholder="Search progress..."
            panelStyleClass="filter-dropdown-panel" appendTo="body" />
        </div>
        <div class="filter-field">
          <label for="clientFilter" class="filter-label">Client</label>
          <p-select id="clientFilter" [(ngModel)]="selectedClientFilter" (ngModelChange)="onClientFilterChange()"
            [options]="clientFilterOptions" optionLabel="label" optionValue="value" placeholder="All"
            [showClear]="true" [filter]="true" filterPlaceholder="Search client..."
            panelStyleClass="filter-dropdown-panel" appendTo="body" />
        </div>
        <div class="filter-field">
          <label for="accountManagerFilter" class="filter-label">Account Manager</label>
          <p-select id="accountManagerFilter" [(ngModel)]="selectedAccountManagerFilter"
            (ngModelChange)="onAccountManagerFilterChange()" [options]="accountManagerFilterOptions"
            optionLabel="label" optionValue="value" placeholder="All" [showClear]="true"
            [filter]="true" filterPlaceholder="Search account manager..."
            panelStyleClass="filter-dropdown-panel" appendTo="body" />
        </div>
      </div>
      <div class="filter-bar-actions">
        <!-- Three explicit toggles, matching the Presales Details page: the
             available views are discoverable and the active one is obvious. -->
        <button type="button" class="view-toggle-icon"
                [class.active]="viewMode === 'list'"
                (click)="setViewMode('list')"
                pTooltip="List view" tooltipPosition="top">
          <i class="pi pi-list"></i>
        </button>
        <button type="button" class="view-toggle-icon"
                [class.active]="viewMode === 'grid'"
                (click)="setViewMode('grid')"
                pTooltip="Grid view" tooltipPosition="top">
          <i class="pi pi-th-large"></i>
        </button>
        <button type="button" class="view-toggle-icon"
                [class.active]="viewMode === 'kanban'"
                (click)="setViewMode('kanban')"
                pTooltip="Kanban view (by progress)" tooltipPosition="top">
          <i class="pi pi-objects-column"></i>
        </button>
        <button *ngIf="hasActiveFilters()" type="button" class="btn-clear-filters" (click)="clearFilters()" title="Clear all filters">
          <i class="pi pi-filter-slash"></i>
        </button>
      </div>
    </div>

    <!-- List View -->
    <div *ngIf="viewMode === 'list'" class="list-view-container">
      <p-table
        [scrollable]="true"
        scrollHeight="flex"
        [value]="filteredProjects"
        [loading]="loading"
        [tableStyle]="{ 'width': '100%', 'table-layout': 'fixed' }"
        styleClass="p-datatable no-column-lines compact-striped-table resize-handles-visible projects-list-table"
        [resizableColumns]="true"
        columnResizeMode="expand"
        [rowHover]="true">

        <ng-template pTemplate="colgroup">
          <colgroup>
            <col style="width: 10%">
            <col style="width: 10%">
            <col style="width: 6%">
            <col style="width: 8%">
            <col style="width: 5%">
            <col style="width: 7%">
            <col style="width: 11%">
            <col style="width: 11%">
            <col style="width: 5%">
            <col style="width: 5%">
            <col style="width: 5%">
          </colgroup>
        </ng-template>

        <ng-template pTemplate="header">
          <tr>
            <th pResizableColumn pSortableColumn="name" class="th-project-name">
              Project
              <p-sortIcon field="name" />
            </th>
            <th pResizableColumn pSortableColumn="managerName" class="th-pm-am" pTooltip="Project Manager / Account Manager" tooltipPosition="top">
              PM/AM
              <p-sortIcon field="managerName" />
            </th>
            <th pResizableColumn pSortableColumn="clientName">Client <p-sortIcon field="clientName" /></th>
            <th pResizableColumn pSortableColumn="serviceGroupName">Service Group <p-sortIcon field="serviceGroupName" /></th>
            <th pResizableColumn pSortableColumn="status">Status <p-sortIcon field="status" /></th>
            <th pResizableColumn pSortableColumn="progress">Progress <p-sortIcon field="progress" /></th>
            <th pResizableColumn pSortableColumn="startDate">Start Date <p-sortIcon field="startDate" /></th>
            <th pResizableColumn pSortableColumn="endDate">End Date <p-sortIcon field="endDate" /></th>
            <th pResizableColumn pSortableColumn="plannedEstimateDays" pTooltip="Planned (Days)" tooltipPosition="top">Planned <p-sortIcon field="plannedEstimateDays" /></th>
            <th pResizableColumn pSortableColumn="actualEffortDays" pTooltip="Actual (Days)" tooltipPosition="top">Actual <p-sortIcon field="actualEffortDays" /></th>
            <th pResizableColumn pSortableColumn="remainingEffortDays" pTooltip="Remaining (Days)" tooltipPosition="top">Remain. <p-sortIcon field="remainingEffortDays" /></th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-project>
          <tr (click)="showProjectDetails(project, $event)" class="cursor-pointer">
            <td class="td-project-name">
              <div class="project-name-cell" [pTooltip]="(project.name || '') + (project.projectCode ? ' (' + project.projectCode + ')' : '')" tooltipPosition="top">
                <span class="project-name-main">{{ project.name || '-' }}</span>
                <span class="project-code-sublabel">{{ project.projectCode || '-' }}</span>
              </div>
            </td>
            <td class="td-pm-am">
              <div class="pm-am-cell" [pTooltip]="'PM: ' + (project.managerName || '-') + ' | AM: ' + (project.accountManagerName || '-')" tooltipPosition="top">
                <span class="pm-am-name">{{ project.managerName || '-' }}</span>
                <span class="pm-am-name pm-am-name--secondary">{{ project.accountManagerName || '-' }}</span>
              </div>
            </td>
            <td class="td-truncate" [pTooltip]="project.clientName || '-'" tooltipPosition="top">{{ project.clientName || '-' }}</td>
            <td class="td-truncate" [pTooltip]="project.serviceGroupName || '-'" tooltipPosition="top">{{ project.serviceGroupName || '-' }}</td>
            <td class="text-center">
              <span class="status-badge-cell" [ngClass]="getStatusBadgeClass(project.status)">{{ project.status || 'N/A' }}</span>
            </td>
            <td class="text-center">
              <span class="progress-badge-cell" [ngClass]="getProgressBadgeClass(project.progress)">{{ project.progress || 'N/A' }}</span>
            </td>
            <td>{{ formatDate(project.startDate) }}</td>
            <td>{{ formatDate(project.endDate) }}</td>
            <td class="text-right">{{ project.plannedEstimateDays != null ? (project.plannedEstimateDays | number:'1.2-2') : '-' }}</td>
            <td class="text-right">{{ project.actualEffortDays != null ? (project.actualEffortDays | number:'1.0-0') : '-' }}</td>
            <td class="text-right">{{ project.remainingEffortDays != null ? (project.remainingEffortDays | number:'1.2-2') : '-' }}</td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr class="table-empty-row">
            <td colspan="11" class="table-empty-cell">
              <div class="empty-state">
                <div class="empty-icon"><i class="pi pi-inbox"></i></div>
                <p class="empty-message">No active projects found</p>
                <p class="empty-description">Adjust filters or clear them to see more</p>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <!-- Grid View -->
    <div *ngIf="viewMode === 'grid'" class="grid-view">
      <div *ngIf="loading" class="grid-loading">
        <i class="pi pi-spin pi-spinner"></i>
        <span>Loading projects...</span>
      </div>
      <div *ngIf="!loading && filteredProjects.length === 0" class="empty-state-wrapper">
        <div class="empty-state">
          <div class="empty-icon"><i class="pi pi-inbox"></i></div>
          <p class="empty-message">No active projects found</p>
          <p class="empty-description">Adjust filters or clear them to see more</p>
        </div>
      </div>
      <div *ngIf="!loading && filteredProjects.length > 0" class="grid-container">
        <div
          *ngFor="let project of filteredProjects; trackBy: trackByProjectId"
          class="grid-card"
          (click)="showProjectDetails(project, $event)">
          <div class="grid-card-header" [ngClass]="getStatusIconClass(project.status)">
            <span class="grid-card-status-dot" [ngClass]="getStatusIconClass(project.status)" [pTooltip]="project.status || 'N/A'" tooltipPosition="top"></span>
            <div class="grid-card-title-wrap">
              <span class="grid-card-title" [pTooltip]="project.name" tooltipPosition="top">{{ project.name }}</span>
              <span class="grid-card-code">{{ project.projectCode || '-' }}</span>
            </div>
          </div>
          <div class="grid-card-body">
            <div class="grid-card-row">
              <i class="pi pi-building"></i>
              <span class="grid-card-value" [pTooltip]="project.clientName || 'No Client'" tooltipPosition="top">{{ project.clientName || 'No Client' }}</span>
            </div>
            <div class="grid-card-row grid-card-row--pm-am">
              <i class="pi pi-users"></i>
              <div class="grid-card-pm-am">
                <span [pTooltip]="'PM: ' + (project.managerName || '-')" tooltipPosition="top">{{ project.managerName || 'No PM' }}</span>
                <span class="grid-card-am" [pTooltip]="'AM: ' + (project.accountManagerName || '-')" tooltipPosition="top">{{ project.accountManagerName || 'No AM' }}</span>
              </div>
            </div>
          </div>
          <div class="grid-card-footer">
            <span class="grid-card-progress-badge" [ngClass]="getProgressBadgeClass(project.progress)">{{ project.progress || 'N/A' }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- ============ KANBAN VIEW (one column per progress state) ============
         Reuses the shared .kanban-* board styles from styles/_presales.scss so
         this board and the presales boards look and behave identically. -->
    <div *ngIf="viewMode === 'kanban'" class="kanban-view kanban-view--progress">
      <div class="empty-state" *ngIf="!loading && filteredProjects.length === 0">
        <div class="empty-icon"><i class="pi pi-inbox"></i></div>
        <p class="empty-message">No projects match these filters</p>
        <p class="empty-description">Try clearing a filter to widen the results.</p>
      </div>

      <div class="kanban-scroll" *ngIf="filteredProjects.length > 0">
        <div class="kanban-grid">
          <div class="kanban-col" *ngFor="let col of visibleKanbanColumns"
               [ngClass]="col.cssClass"
               [class.is-empty]="col.projects.length === 0">
            <div class="kanban-col-head">
              <div class="kanban-col-head-top">
                <span class="kanban-col-title">
                  <span class="dot" [ngClass]="col.cssClass"></span>{{ col.label }}
                </span>
                <span class="kanban-col-count">{{ col.projects.length }}</span>
              </div>
            </div>
            <div class="kanban-col-body">
              <div class="kanban-card kanban-card--rich"
                   *ngFor="let project of col.projects; trackBy: trackByProjectId"
                   [ngClass]="'rag-' + getStatusSeverity(project.status)"
                   [class.is-overdue]="calcOverdueDays(project.endDate)"
                   (click)="showProjectDetails(project, $event)">

                <!-- Row 1: RAG health as a word (it is the card's edge colour too)
                     plus the code, which the presales card keeps on its meta row. -->
                <div class="kanban-card-top">
                  <span class="k-stage" [ngClass]="getStatusBadgeClass(project.status)">
                    {{ project.status || 'No status' }}
                  </span>
                </div>

                <h4 class="kanban-card-title" [pTooltip]="project.name" tooltipPosition="top"
                    [tooltipOptions]="{ showDelay: 600 }">{{ project.name }}</h4>

                <div class="kanban-card-meta">
                  <span class="k-client" [pTooltip]="project.clientName || 'No client set'" tooltipPosition="top">
                    <i class="pi pi-building"></i>{{ project.clientName || 'No client set' }}
                  </span>
                  <span class="k-code" *ngIf="project.projectCode">{{ project.projectCode }}</span>
                </div>

                <!-- Effort against the planned estimate — the delivery equivalent
                     of the presales card's deal value and win bar. -->
                <div class="kanban-card-value" *ngIf="effortPct(project) !== null">
                  <span class="k-money">
                    {{ project.actualEffortDays || 0 }}<span class="cur">/{{ project.plannedEstimateDays }}d</span>
                  </span>
                  <span class="k-win" [class.k-win--over]="effortPct(project)! > 100"
                        [pTooltip]="'Effort used against planned estimate'" tooltipPosition="top">
                    <span class="k-win-bar"><span class="k-win-fill"
                          [style.width.%]="effortBarPct(project)"></span></span>
                    {{ effortPct(project) }}%
                  </span>
                </div>

                <div class="kanban-card-foot">
                  <span class="k-owner" [pTooltip]="'Manager: ' + (project.managerName || 'Unassigned')"
                        tooltipPosition="top">
                    <span class="k-avatar" [style.--k-hue]="avatarHue(project.managerName)">{{ initials(project.managerName) }}</span>
                    <span class="k-owner-name">{{ project.managerName || 'Unassigned' }}</span>
                  </span>
                  <span class="k-close k-overdue" *ngIf="calcOverdueDays(project.endDate) as od">
                    <i class="pi pi-exclamation-circle"></i>{{ od }}d over
                  </span>
                  <span class="k-close" *ngIf="!calcOverdueDays(project.endDate) && project.endDate"
                        [class.k-close--soon]="isEndingSoon(project.endDate)"
                        [pTooltip]="'Ends: ' + shortDate(project.endDate)" tooltipPosition="top">
                    <i class="pi pi-calendar"></i>{{ endLabel(project.endDate) }}
                  </span>
                </div>
              </div>
              <div class="kanban-empty" *ngIf="col.projects.length === 0">No projects</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Project Details Dialog -->
<app-project-details
  *ngIf="selectedProject"
  [project]="selectedProject"
  [visible]="displayDetailsDialog"
  (visibleChange)="displayDetailsDialog = $event"
  (close)="hideDetailsDialog()"
  (projectUpdated)="onProjectUpdated($event)" />
